import { ApiEndPoint } from '@/domains/api/api.entity';
import type {
  ResetPasswordResultApi,
  UpdateUserRolePayload,
  UpdateUserRoleResponse,
  UserApiResponse,
} from '@/domains/user/user.entity';
import { apiRequest } from './apiRequest';

/**
 * Servicio HTTP para gestión de usuarios del sistema
 * Responsabilidad: Comunicación con endpoints de usuarios, roles y contraseñas
 */
class UserApiService {
  /**
   * Obtiene la lista completa de usuarios del sistema con sus roles asignados
   */
  async getUsers(): Promise<UserApiResponse> {
    const usersResponse = await apiRequest.get<UserApiResponse>({
      route: ApiEndPoint.USERS,
    });

    return usersResponse;
  }

  /**
   * Actualiza el rol asignado a un usuario específico
   * @param payload - Datos de actualización (código de funcionario y nuevo código de rol)
   */
  async updateUserRole(
    payload: UpdateUserRolePayload,
  ): Promise<UpdateUserRoleResponse> {
    const updateResponse = await apiRequest.put<
      UpdateUserRoleResponse,
      UpdateUserRolePayload
    >({
      route: ApiEndPoint.USERS,
      payload,
    });

    return updateResponse;
  }

  /**
   * Resetea la contraseña de un usuario generando una contraseña temporal
   * @param codFuncionario - Código único del funcionario
   */
  async resetPasswordUser(
    codFuncionario: number,
  ): Promise<ResetPasswordResultApi> {
    const resetPasswordResponse = await apiRequest.put<
      ResetPasswordResultApi,
      undefined
    >({
      route: ApiEndPoint.RESET_PASSWORD,
      param: `/${codFuncionario}/reset-password`,
      payload: undefined,
    });

    return resetPasswordResponse;
  }
}

export const userApiService = new UserApiService();
